<template>
  <div class="s1">
    <div class="container">
      <!-- <img src="@/assets/home/banner.png" class="banner" alt="" /> -->
      <img src="@/assets/home/s1/text.png" alt="" class="text" />
      <div class="tumbler-box">
        <div class="text-bg-box">
          <img src="@/assets/home/s1/text-bg.png" class="text-bg" alt="" />
        </div>
        <img src="@/assets/home/s1/bz.png" class="tumbler" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.s1 {
  width: 100%;
  // height: 750px;
  background: #e6328d;
  // padding-top: 203px;

  box-sizing: border-box;
  overflow: hidden;
  margin: 0 auto;
  position: relative;
  .container {
    margin: 0 auto;
    text-align: left;
    margin-top: 203px;

    .text {
      width: 54.56%;
    }
  }
}

@media screen {
  @media (min-width: 1617px) {
    .s1 {
      min-width: 1600px;
      height: 750px;
    }
    .container {
      width: 1600px;
      // height: calc(100vw * 0.46875);
      // height: ;
      position: relative;
      .tumbler-box {
        top: 136px;
        position: relative;
        // bottom: 0;

        .text-bg-box {
          overflow: hidden;
          width: 100%;
          height: 100%;
          .text-bg {
            width: 1460px;
          }
        }

        .tumbler {
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: 1004px;
        }
      }
    }
  }

  @media (min-width: 1201px) and (max-width: 1616px) {
    .s1 {
      // height: calc(100vw * 0.447);
      min-height: calc(1200px * 0.46875);
    }
    .container {
      max-width: 1600px;
      width: 90%;
      position: relative;

      .tumbler-box {
        margin-top: 130px;
        position: relative;
        text-align: left;
        width: 100%;
        margin-top: 11.81%;
        .text-bg {
          width: 1100px;
        }
        .tumbler {
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: calc(100% * 0.6275);
          min-width: 632.2px;
        }
      }
      // .tumbler-box {
      //   width: 100%;
      //   position: absolute;
      //   bottom: 0;
      //   // width: 731px;
      //   margin-top: 11.81%;
      //   .text-bg {
      //     width: 100%;
      //   }
      //   .tumbler {
      //     position: absolute;
      //     top: -120%;
      //     right: 0;
      //     width: calc(100% * 0.6275);
      //     min-width: 632.2px;
      //   }
      // }
    }
  }

  @media (max-width: 1200px) {
    .s1 {
      width: 1200px;
      // height: calc(1200px * 0.47);
      min-height: 552px;
    }
    .container {
      width: 1100px;
      margin: 0 auto;

      text-align: center;
      // .banner {
      //   width: 1200px;
      // }

      .tumbler-box {
        margin-top: 130px;
        position: relative;
        text-align: left;
        width: 1100px;
        margin-top: 11.81%;
        .text-bg {
          width: 1100px;
        }
        .tumbler {
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: calc(100% * 0.6275);
          min-width: 632.2px;
        }
      }
    }
  }
}
</style>
